import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/Select'
import type { Group } from './api'

interface Props {
  groups: Group[]
  value: string
  onChange: (id: string) => void
}

// Only bottom-level groups can hold products, so only they are listed.
export default function MoveToSelect({ groups, value, onChange }: Props) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-8 w-64" aria-label="Move to group">
        <SelectValue placeholder="Move to…" />
      </SelectTrigger>
      <SelectContent align="start">
        {groups.filter((g) => g.is_leaf).map((g) => (
          <SelectItem key={g.id} value={g.id}>{g.path}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
